import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRouter } from "./app-routing.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbDatepicker } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { ToastrModule } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms';
import { BarRatingModule } from "ngx-bar-rating";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgCircleProgressModule } from "ng-circle-progress"

import { AppComponent } from "./app.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { RtlComponent } from "./rtl/rtl.component";
import { NavbarComponent } from "./common/navbar/navbar.component";
import { SidebarComponent } from "./common/sidebar/sidebar.component";
import { FooterComponent } from "./common/footer/footer.component";
import { SettingsPanelComponent } from "./common/settings-panel/settings-panel.component";
import { SpinnerComponent } from './common/spinner/spinner.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServicesModule } from './common/services/services.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { InterceptorsModule } from './common/interceptors/interceptors.module';
import { GuardsModule } from './common/guards/guards.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoginComponent } from './login/login.component';
import { CommonsModule } from './common/commons.module';
import { LiveViewComponent } from './live-view/live-view.component';
import { LiveViewCounterComponent } from './live-view/live-view-counter/live-view-counter.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from "primeng/inputswitch";
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { DropdownModule } from "primeng/dropdown";
import { LiveViewChartsComponent } from './live-view/live-view-charts/live-view-charts.component';
import { SettingsComponent } from './settings/settings.component';
import { VisitorLimitComponent } from './settings/visitor-limit/visitor-limit.component';
import { OpeningHoursComponent } from './settings/opening-hours/opening-hours.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    RtlComponent,
    SettingsPanelComponent,
    SpinnerComponent,
    LoginComponent,
    LiveViewComponent,
    LiveViewCounterComponent,
    LiveViewChartsComponent,
    StatisticsComponent,
    SettingsComponent,
    VisitorLimitComponent,
    OpeningHoursComponent
  ],
  imports: [
    AppRouter,
    BrowserModule,
    CommonModule,
    NgbModule,
    BarRatingModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    FormsModule,
    NgbDatepicker,
    NgChartsModule,
    NgCircleProgressModule.forRoot({
      // optional global defaults:
      radius: 60,
      outerStrokeWidth: 10,
      innerStrokeWidth: 5,
      showSubtitle: true,
      animationDuration: 300
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true
    }),
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    NgbNavModule,
    HttpClientModule,
    ServicesModule,
    InterceptorsModule,
    GuardsModule,
    CommonsModule,
    CalendarModule,
    InputSwitchModule,
    SelectButtonModule,
    TableModule,
    DropdownModule,
    CheckboxModule,
    ProgressBarModule
  ],
  providers: [
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
